import { httpRequest } from '@calendly/http-tools'

import { FILTER_CATEGORY_BY_WHOM, FILTER_CATEGORY_CATEGORY, FILTER_CATEGORY_ACTIVITY } from './constants'

export const getEntries = (params) => httpRequest({
  url: '/api/organization/activity_log/entries',
  method: 'GET',
  params
})

export const getAggregations = () => {
  const params = {
    fields: [
      {
        name: FILTER_CATEGORY_BY_WHOM,
        display_field: 'actor.display_name',
        value_field: 'actor.uri'
      },
      {
        name: FILTER_CATEGORY_CATEGORY,
        display_field: 'namespace',
        value_field: 'namespace',
        humanize_display_field: true
      },
      {
        name: FILTER_CATEGORY_ACTIVITY,
        display_field: 'action',
        value_field: 'action',
        humanize_display_field: true
      }
    ]
  }

  return httpRequest({
    url: '/api/organization/activity_log/aggregations',
    method: 'GET',
    params
  })
}

export const createExport = (params = {}) => httpRequest({
  url: '/api/organization/activity_log/export',
  method: 'POST',
  params
})

export const createOutgoingCommsExport = () => httpRequest({
  url: '/api/organization/outgoing_communications/export',
  method: 'POST'
})
